import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-articulo-subcategoria',
  templateUrl: './articulo-subcategoria.component.html',
  styleUrls: ['./articulo-subcategoria.component.css']
})
export class ArticuloSubcategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/articulo-subcategoria/articulo-subcategoria.component.ts